<template lang="pug">
div
  el-form-item(label="显示步进器")
    el-switch(v-model="controls")
  el-form-item(label="前缀文字")
    el-input(v-model.trim="prefix")
  el-form-item(label="后缀文字")
    el-input(v-model.trim="suffix")
  el-form-item(label="千分格式化")
    el-switch(v-model="formatNum")
</template>
<script>
import { mapVFOptions, settingMixin } from "@/CommonDP/VForm/utils";

export default {
  mixins: [settingMixin],
  data() {
    return {};
  },
  computed: {
    ...mapVFOptions(["controls", "prefix", "suffix", "formatNum"])
  }
};
</script>
